import React, { useState } from 'react';
import { useAuth } from '../../services/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Auth.css';

const Login = () => {
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    console.log('🔄 Frontend login attempt:', credentials.email);

    const result = await login(credentials);
    console.log('📊 Frontend login result:', result);

    if (result.success) {
      console.log('✅ Frontend: Login successful, redirecting to /');
      navigate('/');
    } else {
      console.log('❌ Frontend: Login failed:', result.error);
      setError(result.error);
    }

    setLoading(false);
  };

  // Auto-fill for testing
  const fillDemoCredentials = () => {
    setCredentials({
      email: 'gaurav@zoho.com',
      password: 'qwerty'
    });
  };

  return (
    <div className="auth-container">
      {/* Floating background elements */}
      <div className="floating-bg-2"></div>
      
      <div className="auth-card">
        <div className="auth-header">
          <div className="logo-container">
            <img src="/logo.png" alt="IMS Logo" className="auth-logo" />
          </div>
          <h1>Inventory Management System</h1>
          <p>Sign in to your account</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {error && (
            <div className="alert alert-danger">
              <i className="fas fa-exclamation-circle"></i>
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="email" className="form-label">
              <i className="fas fa-envelope"></i>
              Email Address
            </label>
            <input
              type="email"
              id="email"
              name="email"
              className="form-control"
              value={credentials.email}
              onChange={handleChange}
              required
              placeholder="Enter your email address"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">
              <i className="fas fa-lock"></i>
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              className="form-control"
              value={credentials.password}
              onChange={handleChange}
              required
              placeholder="Enter your password"
            />
          </div>

          <div className="form-actions">
            <button
              type="submit"
              className="btn btn-primary auth-btn"
              disabled={loading}
            >
              {loading ? (
                <>
                  <div className="spinner-small"></div>
                  Signing In...
                </>
              ) : (
                <>
                  <i className="fas fa-sign-in-alt"></i>
                  Sign In
                </>
              )}
            </button>

            {/* <button
              type="button"
              className="btn btn-secondary auth-btn"
              onClick={fillDemoCredentials}
            >
              <i className="fas fa-magic"></i>
              Fill Demo Credentials
            </button> */}
          </div>
        </form>

        <div className="auth-footer">
          {/* <div className="demo-info">
            <p><strong>Demo Credentials:</strong></p>
            <p>Email: gaurav@zoho.com | Password: qwerty</p>
          </div> */}
          <div className="security-note">
            <i className="fas fa-shield-alt"></i>
            <span>Your credentials are secure and encrypted</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;